import * as React from 'react';
import {Helmet} from 'react-helmet';

export const generateHelmet = seo => {
  return (<Helmet
    title={seo.title}
    meta={[
      {name: 'description', content: `${seo.description}`},
      {name: 'og:title', content: `${seo.title}`},
      {name: 'og:description', content: `${seo.description}`},
      {name: 'X-UA-Compatible', content: 'IE=Edge'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'},
    ]}
    link={[
      {rel: 'canonical', href: `${seo.url}`},
    ]}
    />);
};

export const removeDuplicatedSEOTags = () => {
  const elementsToRemove = [
    'headTitle',
    'headDescription',
    'headOGtitle',
    'headOGDescription',
    'headCanonical'
  ];
  for (let i = 0; i < elementsToRemove.length; i++) {
    const element = document.getElementById(elementsToRemove[i]);
    if (element) {
      element.parentNode.removeChild(element);
    }
  }
};
